import "./Banner.css";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import Modals from "../Modals/Modals";
const Banner = ({...props}) => {
  console.log(props,'/[Banner.tsx]')
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const {userInfo} = props;
  
  const getCoupon = async () => {
    console.log(userInfo?.membership);
    if(userInfo?.membership?.subscription) {
      return setShow(true);
    }
    navigate(`coupon`,{state:'not_reload'});
  }
  
  return (
    <>
      <div className={`bg-primary banner`}>
        <div className={`flex max-md:block items-center justify-center`}>
          <p className={`tit max-md:mb-3 max-md:text-center`}>🎁 선물 받은 쿠폰이 있나요?</p>
          {/*<button onClick={()=>navigate(`coupon`)} className={`btn_coupon`}>쿠폰 등록</button>*/}
          <button onClick={getCoupon} className={`btn_coupon max-md:w-[100%]`}>쿠폰 등록</button>
        </div>
      </div>
      <Modals
        // message={`이미 사용중인 상품이 있어서 새로운 쿠폰을 등록할 수 없어요`}
        show={show}
        alertType={`default`}
        onClose={(res:any)=>setShow(res)}
      >
        이미 사용중인 상품이 있어서<br/>새로운 쿠폰을 등록할 수 없어요
      </Modals>
    </>
  )
}
export default Banner;